import React, { useState } from 'react';
import classes from '../EventsPage/EventsPage.module.css';
import ListStatus from '../../ReusableComponents/ListStatus/ListStatus';
import PageHeader from '../../ReusableComponents/PageHeader/PageHeader';
import Lightbox from '../../ReusableComponents/Lightbox/Lightbox';
import img from '../../assets/parli.png';
import useInfiniteList from '../../CustomHooks/useInfiniteList';

// Declared outside the component so their identity is stable across renders.
const selectAlbums = (result) => result?.data;
const getAlbumKey = (album, index) => album?._id ?? album?.id ?? album?.title ?? `album-${index}`;

function GalleryPage() {
  // { photos, index, albumTitle } while the lightbox is open.
  const [viewing, setViewing] = useState(null);

  const {
    items: albums,
    loading,
    loadingMore,
    error,
    hasMore,
    sentinelRef,
    reload,
  } = useInfiniteList({
    endpoint: '/album',
    method: 'get',
    selectItems: selectAlbums,
    getKey: getAlbumKey,
  });

  return (
    <main className={classes.eventsPage}>
      <PageHeader
        eyebrow="In pictures"
        title="Gallery"
        image={img}
        meta={albums.length > 0 ? `${albums.length} ${albums.length === 1 ? 'album' : 'albums'}` : undefined}
      />

      <section className={classes.mainContainer}>
        {albums.map((album, index) => {
          const photos = album?.uploadDoc ?? [];

          return (
            <div key={getAlbumKey(album, index)} className={classes.galleryItem}>
              <div className={classes.albumHead}>
                <h2 className={classes.albumTitle}>{album?.title}</h2>
                <span className={classes.albumCount}>
                  {photos.length} {photos.length === 1 ? 'photo' : 'photos'}
                </span>
              </div>

              {photos.length === 0 ? (
                <p className={classes.emptyAlbum}>No photos in this album yet.</p>
              ) : (
                <div className={classes.imgContainer}>
                  {photos.map((doc, idx) => (
                    <button
                      type="button"
                      key={doc?.id ?? doc?.url ?? idx}
                      className={classes.photo}
                      onClick={() =>
                        setViewing({ photos, index: idx, albumTitle: album?.title })
                      }
                      aria-label={`View photo ${idx + 1} of ${photos.length} from ${album?.title ?? 'this album'}`}
                    >
                      <img
                        src={doc?.url}
                        alt={`${album?.title ?? 'Gallery'} ${idx + 1}`}
                        loading="lazy"
                      />
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}

        <ListStatus
          sentinelRef={sentinelRef}
          loading={loading}
          loadingMore={loadingMore}
          error={error}
          hasMore={hasMore}
          isEmpty={albums.length === 0}
          onRetry={reload}
          emptyLabel="No albums to show yet."
          endLabel="No more albums."
        />
      </section>

      {viewing && (
        <Lightbox
          photos={viewing.photos}
          startIndex={viewing.index}
          title={viewing.albumTitle}
          onClose={() => setViewing(null)}
        />
      )}
    </main>
  );
}

export default GalleryPage
